import { hc } from "hono/client";
import { AppType } from "@/app/api/[[...route]]/route";
import { getBaseUrl } from "./getBaseUrl";

const baseUrl = getBaseUrl();

export const client = hc<AppType>(baseUrl);
